import { lazy, Suspense } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import loading from "./assets/loading.svg";
import { HelmetProvider } from 'react-helmet-async';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';



// Lazy-loaded components
const Header = lazy(() => import('./components/header/Header'));
const Footer = lazy(() => import('./components/footer/Footer'));
const Home = lazy(() => import('./pages/Home/Home'));
function Layout() {
  const location = useLocation();
  const navigate = useNavigate();





  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
      <Footer />

    </>

  );
}


function App() {
  return (
    <div className="App">
          <HelmetProvider>

            <Router>
              <Suspense
                fallback={
                  <div
                    className="d-flex justify-content-center align-items-center lazy-loader"
                    style={{ maxWidth: '100vw', height: '100vh' }}
                  >
                    <div className="gif-container">
                      <img src={loading} className="website-preloader" alt="Preloader" />
                    </div>
                  </div>
                }
              >
                <Layout />
              </Suspense>
            </Router>
          </HelmetProvider>
    </div>
  );
}

export default App;
